<script>
import HomeService2024 from "../../_commons/fr/components2024/HomeService2024.vue";
import HomeServicePack2024 from "../../_commons/fr/components2024/HomeServicePack2024.vue";
import image_mixin from "../../_commons/fr/mixins/image_mixin";


export default {
    name: "HomeServiceSection2024",
    components: {HomeServicePack2024, HomeService2024},
    mixins: [image_mixin],
    data() {
        return {
            gifts: [
                `MACHINE À CAFÉ <span> compatible capsules</span> `, "Casque JBL", "Aspirateur Robot", "SmartWatch" , "Airfryer",
            ],
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        }
    },
}
</script>

<template>
    <div class="home-service-wrapper">
        <HomeService2024>
            <template #image>
                <img src="/images/TA_2025/icons/eur_transparent.png" alt="icon-euro" class="home-service__icon">
            </template>
            <template #title>
                <h3>De quels services <br> bénéficierez-vous avec <br> l’offre à 2€/2 mois</h3>
            </template>
            <template #service-text>
                <p>Notre pack d'avantages vous permet de <br> faire des économies, de vous protéger et <br> d’en apprendre plus sur des sujets variés.</p>
            </template>
        </HomeService2024>
        <hr class="line-break">
        <HomeServicePack2024 :box="box" :gifts="gifts"></HomeServicePack2024>
        <hr class="line-break">
    </div>
</template>

<style scoped>

</style>
